import { Input, Button, Badge, Dropdown } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Logo/Logo";
import "./Menu.css";
import { UserContext } from "../../context/User.context";
import { useContext, useState } from "react";
import { LanguageContext } from "../../context/Language.contex";

const { Search } = Input;

const Menu = ({ filterLength }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const { toggleLanguage, currentLanguage, language } =
    useContext(LanguageContext);

  // Fungsi untuk logout
  const logout = () => {
    setLoading(true);
    setTimeout(() => {
      if (!loading) {
        setUser(null);
        localStorage.clear();
        navigate("/login");
      }
    }, 1000); // Ubah timeout menjadi nilai tetap (misalnya 1000ms)
  };

  // Daftar menu dropdown untuk pengguna
  const userDropdownItems = [
    {
      key: "1",
      label: (
        <div style={{ textAlign: "center" }}>
          <a
            style={{ color: "black" }}
            onClick={() => {
              navigate("/user");
            }}
          >
            <DashboardOutlined style={{ fontSize: 15, marginRight: 5 }} />
            Dashboard
          </a>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          onClick={logout}
          icon={<LogoutOutlined />}
          loading={loading}
          type="primary"
          size="middle"
          danger
          style={{ width: "100%" }}
        >
          Logout
        </Button>
      ),
      disabled: true,
    },
  ];

  // Daftar opsi bahasa untuk dropdown
  const languageOptions = [
    {
      key: "id",
      label: "Bahasa Indonesia",
      onClick: () => toggleLanguage("id"), // Set to Indonesian
    },
    {
      key: "en",
      label: "English",
      onClick: () => toggleLanguage("en"), // Set to English
    },
    {
      key: "chi",
      label: "中文 (Chinese)",
      onClick: () => toggleLanguage("chi"), // Set to Chinese
    },
  ];

  return (
    <div className="menu">
      {/* Logo */}
      <Link to="/" className="menuItem">
        <Logo />
      </Link>

      {/* Tampilan jika user sudah login */}
      {user ? (
        <>
          <div className="btn-menu">
            {/* Dropdown untuk menu user */}
            <Dropdown
              menu={{
                items: userDropdownItems,
              }}
              placement="bottom"
              arrow
            >
              <Button icon={<UserOutlined style={{ fontSize: 22 }} />} />
            </Dropdown>

            {/* Dropdown untuk pemilihan bahasa */}
            <Dropdown
              menu={{
                items: languageOptions,
              }}
              placement="bottomRight"
              trigger={["click"]}
              overlayStyle={{ minWidth: 150 }}
            >
              <Button
                icon={<GlobalOutlined style={{ fontSize: 16 }} />}
                style={{ marginLeft: 10 }}
              >
                {currentLanguage === "id"
                  ? "ID"
                  : currentLanguage === "en"
                  ? "EN"
                  : "ZW"}{" "}
                {/* Menampilkan singkatan bahasa saat ini */}
              </Button>
            </Dropdown>
          </div>
        </>
      ) : (
        // Tampilan jika user belum login
        <>
          <div className="btn-menu">
            <Button
              type="primary"
              onClick={() => {
                navigate("/login");
              }}
            >
              {language[22]} {/* Menggunakan teks terjemahan dari context */}
            </Button>

            <Button>
              <Link to="visitor">{language[12]}</Link>{" "}
              {/* Menggunakan teks terjemahan dari context */}
            </Button>

            {/* Dropdown untuk pemilihan bahasa */}
            <Dropdown
              menu={{
                items: languageOptions,
              }}
              placement="bottomRight"
              trigger={["click"]}
              overlayStyle={{ minWidth: 150 }}
            >
              <Button
                icon={<GlobalOutlined style={{ fontSize: 16 }} />}
                style={{ marginLeft: 10 }}
              >
                {currentLanguage === "id"
                  ? "ID"
                  : currentLanguage === "en"
                  ? "EN"
                  : "ZW"}{" "}
                {/* Menampilkan singkatan bahasa saat ini */}
              </Button>
            </Dropdown>
          </div>
        </>
      )}
    </div>
  );
};

export default Menu;
